import { render, staticRenderFns } from "./rightNav.vue?vue&type=template&id=2bcde346&scoped=true&"
import script from "./rightNav.vue?vue&type=script&lang=js&"
export * from "./rightNav.vue?vue&type=script&lang=js&"
import style0 from "./rightNav.vue?vue&type=style&index=0&id=2bcde346&prod&lang=less&"
import style1 from "./rightNav.vue?vue&type=style&index=1&id=2bcde346&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcde346",
  null
  
)

export default component.exports